import { CHANNELS } from "../shared/channels";
import { UserSettings } from "../shared/types";
import { call } from "./bridge";

// one settings fetch at boot instead of one per view

let pending: Promise<UserSettings> | null = null;

export function cachedSettings(): Promise<UserSettings> {
  pending ??= call<UserSettings>(CHANNELS.settingsGet).catch((error) => {
    pending = null;
    throw error;
  });
  return pending;
}

export function rememberSettings(settings: UserSettings): void {
  pending = Promise.resolve(settings);
}
